var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// openmosh-shaders.ts
var openmosh_shaders_exports = {};
__export(openmosh_shaders_exports, {
  ANIMATED_EFFECTS: () => ANIMATED_EFFECTS,
  EFFECT_SHADERS: () => EFFECT_SHADERS,
  PASSTHROUGH_FRAG: () => PASSTHROUGH_FRAG,
  TEXT_BLEND_FRAG: () => TEXT_BLEND_FRAG,
  VERTEX_SHADER: () => VERTEX_SHADER
});
module.exports = __toCommonJS(openmosh_shaders_exports);
var VERTEX_SHADER = `#version 300 es
layout(location = 0) in vec2 a_position;
out vec2 v_uv;
uniform float u_flipY;
void main() {
  gl_Position = vec4(a_position.x, a_position.y * u_flipY, 0.0, 1.0);
  v_uv = a_position * 0.5 + 0.5;
}`;
var H = `#version 300 es
precision highp float;
uniform sampler2D u_texture;
uniform float u_time;
in vec2 v_uv;
out vec4 outColor;
`;
var BOUNCE_GLSL = `float bounce(float v) {
  v = mod(abs(v), 2.0);
  return v > 1.0 ? 2.0 - v : v;
}
`;
var HUE_ROTATE_GLSL = `vec3 hueRotate(vec3 c, float angle) {
  float rad = angle * 3.14159265 / 180.0;
  float cosA = cos(rad);
  float sinA = sin(rad);
  vec3 k = vec3(0.57735026919);
  return c * cosA + cross(k, c) * sinA + k * dot(k, c) * (1.0 - cosA);
}
`;
var PASSTHROUGH_FRAG = H + `void main() {
  outColor = texture(u_texture, v_uv);
}`;
var TEXT_BLEND_FRAG = `#version 300 es
precision highp float;
uniform sampler2D u_texture;
uniform sampler2D u_texture2;
uniform int u_blendMode;
uniform float u_invert;
uniform float u_opacity;
in vec2 v_uv;
out vec4 outColor;
void main() {
  vec4 mainC = texture(u_texture, v_uv);
  vec4 textC = texture(u_texture2, v_uv);
  if (u_invert > 0.5) {
    textC.rgb = 1.0 - textC.rgb;
  }
  float a = textC.a * u_opacity;
  vec3 mainRgb = mainC.rgb;
  vec3 textRgb = textC.rgb;
  vec3 blended;
  if (u_blendMode == 1) {
    blended = mainRgb * mix(vec3(1.0), textRgb, a);
  } else if (u_blendMode == 2) {
    blended = min(vec3(1.0), mainRgb + textRgb * a * 0.8);
  } else if (u_blendMode == 3) {
    blended = 1.0 - (1.0 - mainRgb) * (1.0 - textRgb * a);
  } else if (u_blendMode == 4) {
    vec3 t = mix(mainRgb, textRgb, a);
    blended = mix(2.0 * mainRgb * t, 1.0 - 2.0 * (1.0 - mainRgb) * (1.0 - t), step(0.5, mainRgb));
  } else if (u_blendMode == 5) {
    blended = mix(mainRgb, abs(mainRgb - textRgb), a);
  } else if (u_blendMode == 6) {
    vec3 t = mix(mainRgb, textRgb, a);
    blended = mainRgb + t - 2.0 * mainRgb * t;
  } else if (u_blendMode == 7) {
    blended = mix(mainRgb, max(vec3(0.0), mainRgb - textRgb), a);
  } else {
    blended = mix(mainRgb, textRgb, a);
  }
  outColor = vec4(clamp(blended, 0.0, 1.0), 1.0);
}`;
function setFloat(gl, locs, name, value) {
  if (locs[name])
    gl.uniform1f(locs[name], value);
}
function setInt(gl, locs, name, value) {
  if (locs[name])
    gl.uniform1i(locs[name], value);
}
function floats(...keys) {
  return (gl, l, v) => {
    for (const key of keys)
      setFloat(gl, l, `u_${key}`, v[key]);
  };
}
var BLUR_H_FRAG = `uniform float u_radius;
uniform vec2 u_resolution;
void main() {
  // Pixel size from the full output resolution (not the pre-pass buffer), so
  // the screen-space blur width is invariant to pre-pass downsampling.
  vec2 px = 1.0 / u_resolution;
  float spread = u_radius * 3.0;
  float sigma = spread * 0.4;
  float invSigma2 = 1.0 / max(sigma * sigma, 0.001);
  vec3 sum = vec3(0.0);
  float totalW = 0.0;
  const int R = 16;
  float step = spread / float(R);
  for (int i = -R; i <= R; i++) {
    float fi = float(i) * step;
    float w = exp(-fi * fi * invSigma2);
    sum += texture(u_texture, v_uv + vec2(fi * px.x, 0.0)).rgb * w;
    totalW += w;
  }
  outColor = vec4(sum / totalW, 1.0);
}`;
var GLOW_VBLUR_FRAG = `uniform float u_radius;
uniform vec2 u_resolution;
void main() {
  vec2 px = 1.0 / u_resolution;
  float spread = u_radius * 3.0;
  float sigma = spread * 0.4;
  float invSigma2 = 1.0 / max(sigma * sigma, 0.001);
  vec3 bloom = vec3(0.0);
  float totalW = 0.0;
  const int R = 16;
  float step = spread / float(R);
  for (int i = -R; i <= R; i++) {
    float fi = float(i) * step;
    float w = exp(-fi * fi * invSigma2);
    vec2 off = vec2(0.0, fi * px.y);
    vec3 s = texture(u_texture, v_uv + off).rgb;
    bloom += s * w;
    totalW += w;
  }
  bloom /= totalW;
  outColor = vec4(bloom, 1.0);
}`;
var EFFECT_SHADERS = {
  pixelate: {
    fragment: H + `uniform float u_size;
void main() {
  vec2 ts = vec2(textureSize(u_texture, 0));
  float cs = max(1.0, u_size);
  vec2 cell = (floor(v_uv * ts / cs) + 0.5) * cs;
  outColor = texture(u_texture, cell / ts);
}`,
    setUniforms: floats("size")
  },
  posterize: {
    fragment: H + `uniform float u_levels;
void main() {
  vec4 c = texture(u_texture, v_uv);
  float n = max(2.0, u_levels);
  outColor = vec4(floor(c.rgb * n + 0.5) / n, c.a);
}`,
    setUniforms: floats("levels")
  },
  solarize: {
    fragment: H + `uniform float u_threshold;
void main() {
  vec4 c = texture(u_texture, v_uv);
  outColor = vec4(mix(c.rgb, 1.0 - c.rgb, step(u_threshold, c.rgb)), c.a);
}`,
    setUniforms: floats("threshold")
  },
  edges: {
    fragment: H + `uniform float u_strength;
uniform float u_mix;
void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  vec4 tl = texture(u_texture, v_uv + vec2(-px.x, -px.y));
  vec4 tm = texture(u_texture, v_uv + vec2( 0.0,  -px.y));
  vec4 tr = texture(u_texture, v_uv + vec2( px.x, -px.y));
  vec4 ml = texture(u_texture, v_uv + vec2(-px.x,  0.0));
  vec4 mr = texture(u_texture, v_uv + vec2( px.x,  0.0));
  vec4 bl = texture(u_texture, v_uv + vec2(-px.x,  px.y));
  vec4 bm = texture(u_texture, v_uv + vec2( 0.0,   px.y));
  vec4 br = texture(u_texture, v_uv + vec2( px.x,  px.y));
  vec4 gx = -tl - 2.0*ml - bl + tr + 2.0*mr + br;
  vec4 gy = -tl - 2.0*tm - tr + bl + 2.0*bm + br;
  vec4 edge = sqrt(gx*gx + gy*gy) * u_strength;
  vec4 orig = texture(u_texture, v_uv);
  outColor = vec4(mix(orig.rgb, edge.rgb, u_mix), orig.a);
}`,
    setUniforms: floats("strength", "mix")
  },
  "neon-edges": {
    fragment: H + `uniform float u_strength;
uniform float u_glow;
uniform float u_bg;

vec3 rgb2hsv(vec3 c) {
  vec4 K = vec4(0.0, -1.0/3.0, 2.0/3.0, -1.0);
  vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
  vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));
  float d = q.x - min(q.w, q.y);
  return vec3(abs(q.z + (q.w - q.y) / (6.0*d + 1e-10)), d / (q.x + 1e-10), q.x);
}

vec3 hsv2rgb(vec3 c) {
  vec4 K = vec4(1.0, 2.0/3.0, 1.0/3.0, 3.0);
  vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
  return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
}

void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  vec4 orig = texture(u_texture, v_uv);

  // Sobel on pre-blurred luminance \u2014 sample each tap as a 2x2 average to
  // suppress pixel-level noise and produce smooth, organic edges
  vec3 luma = vec3(0.299, 0.587, 0.114);
  vec2 h = px * 0.5;
  #define SLUM(o) dot(     texture(u_texture, v_uv+(o)+vec2(-h.x,-h.y)).rgb +     texture(u_texture, v_uv+(o)+vec2( h.x,-h.y)).rgb +     texture(u_texture, v_uv+(o)+vec2(-h.x, h.y)).rgb +     texture(u_texture, v_uv+(o)+vec2( h.x, h.y)).rgb, luma) * 0.25
  vec2 S = px * 1.5;
  float tl = SLUM(vec2(-S.x,-S.y));
  float tm = SLUM(vec2( 0.0,-S.y));
  float tr = SLUM(vec2( S.x,-S.y));
  float ml = SLUM(vec2(-S.x, 0.0));
  float mr = SLUM(vec2( S.x, 0.0));
  float bl = SLUM(vec2(-S.x, S.y));
  float bm = SLUM(vec2( 0.0, S.y));
  float br = SLUM(vec2( S.x, S.y));
  #undef SLUM
  float gx = -tl - 2.0*ml - bl + tr + 2.0*mr + br;
  float gy = -tl - 2.0*tm - tr + bl + 2.0*bm + br;
  float edge = clamp(sqrt(gx*gx + gy*gy) * u_strength, 0.0, 1.0);

  // Neon: original hue at full saturation + brightness
  vec3 hsv = rgb2hsv(orig.rgb);
  vec3 neon = hsv2rgb(vec3(hsv.x, 1.0, 1.0));

  // Glow: 5x5 blur of neon signal from neighborhood
  vec3 glowAccum = vec3(0.0);
  for (int x = -2; x <= 2; x++) {
    for (int y = -2; y <= 2; y++) {
      vec2 off = vec2(float(x), float(y)) * px * 3.0;
      vec3 s = texture(u_texture, v_uv + off).rgb;
      vec3 sh = rgb2hsv(s);
      glowAccum += hsv2rgb(vec3(sh.x, 1.0, 1.0));
    }
  }
  glowAccum /= 25.0;

  // Background: original dimmed in non-edge areas
  vec3 bg = orig.rgb * u_bg * (1.0 - edge);

  // Composite: sharp neon edges + soft glow halo + dim bg
  vec3 result = neon * edge + glowAccum * sqrt(edge) * u_glow * 0.4 + bg;
  outColor = vec4(clamp(result, 0.0, 1.0), orig.a);
}`,
    setUniforms: floats("strength", "glow", "bg")
  },
  bleach: {
    fragment: H + `uniform float u_amount;
void main() {
  vec4 c = texture(u_texture, v_uv);
  float luma = dot(c.rgb, vec3(0.299, 0.587, 0.114));
  vec3 b = (vec3(luma) - 0.5) * 1.5 + 0.5;
  outColor = vec4(mix(c.rgb, clamp(b, 0.0, 1.0), u_amount), c.a);
}`,
    setUniforms: floats("amount")
  },
  sharpen: {
    fragment: H + `uniform float u_amount;
uniform float u_radius;
uniform float u_threshold;
void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0)) * u_radius;
  vec4 c = texture(u_texture, v_uv);

  // 3x3 Gaussian blur (sigma ~0.85)
  // Weights: center=4/16, edges=2/16, corners=1/16
  vec3 blur =
    texture(u_texture, v_uv + vec2(-px.x, -px.y)).rgb * 1.0 +
    texture(u_texture, v_uv + vec2(   0., -px.y)).rgb * 2.0 +
    texture(u_texture, v_uv + vec2( px.x, -px.y)).rgb * 1.0 +
    texture(u_texture, v_uv + vec2(-px.x,    0.)).rgb * 2.0 +
    c.rgb * 4.0 +
    texture(u_texture, v_uv + vec2( px.x,    0.)).rgb * 2.0 +
    texture(u_texture, v_uv + vec2(-px.x,  px.y)).rgb * 1.0 +
    texture(u_texture, v_uv + vec2(   0.,  px.y)).rgb * 2.0 +
    texture(u_texture, v_uv + vec2( px.x,  px.y)).rgb * 1.0;
  blur /= 16.0;

  // Unsharp mask: detail = original - blurred
  vec3 detail = c.rgb - blur;
  vec3 mask = step(vec3(u_threshold), abs(detail));
  outColor = vec4(clamp(c.rgb + detail * u_amount * mask, 0.0, 1.0), c.a);
}`,
    setUniforms: floats("amount", "radius", "threshold")
  },
  mirror: {
    fragment: H + BOUNCE_GLSL + `uniform float u_amount;
uniform int u_side;
uniform float u_position;
void main() {
  vec2 uv = v_uv;
  if (u_side == 0 && uv.x > u_position) uv.x = bounce(2.0 * u_position - uv.x);
  else if (u_side == 1 && uv.x < u_position) uv.x = bounce(2.0 * u_position - uv.x);
  else if (u_side == 2 && uv.y > u_position) uv.y = bounce(2.0 * u_position - uv.y);
  else if (u_side == 3 && uv.y < u_position) uv.y = bounce(2.0 * u_position - uv.y);
  outColor = mix(texture(u_texture, v_uv), texture(u_texture, uv), u_amount);
}`,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_amount", v.amount);
      setInt(gl, l, "u_side", v.side);
      setFloat(gl, l, "u_position", v.position);
    }
  },
  kaleido: {
    fragment: H + BOUNCE_GLSL + `uniform float u_amount;
uniform float u_sides;
uniform float u_angle;
void main() {
  vec2 uv = v_uv - 0.5;
  float r = length(uv);
  float a = atan(uv.y, uv.x) + u_angle * 0.01745329;
  float seg = 6.28318530 / u_sides;
  a = mod(a, seg);
  a = abs(a - seg * 0.5);
  vec2 kUV = vec2(cos(a), sin(a)) * r + 0.5;
  kUV = vec2(bounce(kUV.x), bounce(kUV.y));
  outColor = mix(texture(u_texture, v_uv), texture(u_texture, kUV), u_amount);
}`,
    setUniforms: floats("amount", "sides", "angle")
  },
  "channel-split": {
    fragment: H + `uniform int u_mode;
uniform float u_amount;
uniform float u_angle;
uniform float u_falloff;
uniform float u_saturation;
uniform float u_speed;
void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));

  if (u_mode == 0) {
    // Linear: uniform offset along angle
    float rad = u_angle * 3.14159265 / 180.0;
    vec2 d = vec2(cos(rad), sin(rad)) * u_amount * px;
    outColor = vec4(
      texture(u_texture, v_uv + d).r,
      texture(u_texture, v_uv).g,
      texture(u_texture, v_uv - d).b,
      texture(u_texture, v_uv).a
    );
  } else if (u_mode == 1) {
    // Radial: offset from center, stronger at edges
    vec2 center = vec2(0.5);
    vec2 dir = v_uv - center;
    float dist = length(dir);
    float strength = u_amount * pow(dist, 1.0 + u_falloff * 3.0) * 0.002;
    vec2 offset = normalize(dir + 1e-6) * strength;
    outColor = vec4(
      texture(u_texture, v_uv + offset).r,
      texture(u_texture, v_uv).g,
      texture(u_texture, v_uv - offset).b,
      texture(u_texture, v_uv).a
    );
  } else {
    // Prismatic: position-dependent dispersion + hue rotation, animated
    float t = u_time * u_speed;
    float rad = u_angle * 3.14159265 / 180.0;
    vec2 dir = vec2(cos(rad), sin(rad));
    float pos = dot(v_uv - 0.5, dir);
    float disp = u_amount * 0.0016;
    float drift = sin(t * 0.3) * 0.5;
    vec2 uvR = v_uv - dir * disp * (pos + drift);
    vec2 uvB = v_uv + dir * disp * (pos + drift);
    float r = texture(u_texture, uvR).r;
    float g = texture(u_texture, v_uv).g;
    float b = texture(u_texture, uvB).b;
    vec3 color = vec3(r, g, b);
    float hueShift = pos * u_amount * 0.1 + t * 0.2;
    float cosH = cos(hueShift);
    float sinH = sin(hueShift);
    vec3 k = vec3(0.57735);
    vec3 rotated = color * cosH + cross(k, color) * sinH + k * dot(k, color) * (1.0 - cosH);
    color = mix(color, rotated, u_saturation);
    outColor = vec4(color, 1.0);
  }
}`,
    animated: true,
    setUniforms: (gl, l, v) => {
      const mode = v.mode === "radial" ? 1 : v.mode === "prismatic" ? 2 : 0;
      setInt(gl, l, "u_mode", mode);
      setFloat(gl, l, "u_amount", v.amount);
      setFloat(gl, l, "u_angle", v.angle);
      setFloat(gl, l, "u_falloff", v.falloff);
      setFloat(gl, l, "u_saturation", v.saturation);
      setFloat(gl, l, "u_speed", v.speed);
    }
  },
  "color-correction": {
    fragment: H + HUE_ROTATE_GLSL + `uniform float u_brightness;
uniform float u_contrast;
uniform float u_hue;
uniform float u_saturation;
void main() {
  vec4 c = texture(u_texture, v_uv);
  vec3 rgb = c.rgb * pow(2.0, u_brightness * 2.0);
  float ct = u_contrast < 0.0 ? 1.0 + u_contrast : 1.0 + u_contrast * u_contrast * 10.0;
  rgb = (rgb - 0.5) * ct + 0.5;
  rgb = hueRotate(rgb, u_hue);
  float luma = dot(rgb, vec3(0.299, 0.587, 0.114));
  rgb = mix(vec3(luma), rgb, 1.0 + u_saturation);
  outColor = vec4(clamp(rgb, 0.0, 1.0), c.a);
}`,
    setUniforms: floats("brightness", "contrast", "hue", "saturation")
  },
  vignette: {
    fragment: H + `uniform float u_size;
uniform float u_amount;
void main() {
  vec4 c = texture(u_texture, v_uv);
  float dist = length(v_uv - 0.5);
  float radius = 1.0 - u_size;
  float vig = smoothstep(radius, radius - 0.45, dist);
  outColor = vec4(c.rgb * mix(1.0, vig, u_amount), c.a);
}`,
    setUniforms: floats("size", "amount")
  },
  scanlines: {
    fragment: H + `uniform float u_count;
uniform float u_amount;
void main() {
  vec4 c = texture(u_texture, v_uv);
  float line = sin((v_uv.y + u_time * 0.1) * u_count * 3.14159265) * 0.5 + 0.5;
  outColor = vec4(c.rgb * mix(1.0, line, u_amount), c.a);
}`,
    animated: true,
    setUniforms: floats("count", "amount")
  },
  bulge: {
    fragment: H + `uniform float u_amount;
uniform float u_radius;
void main() {
  vec2 center = vec2(0.5);
  vec2 uv = v_uv - center;
  float dist = length(uv);
  if (dist > 0.0 && dist < u_radius) {
    float pct = dist / u_radius;
    float distortion = pow(pct, 1.0 - u_amount) * u_radius;
    uv = uv / dist * distortion;
  }
  outColor = texture(u_texture, uv + center);
}`,
    setUniforms: floats("amount", "radius")
  },
  jitter: {
    fragment: H + `uniform float u_amount;
uniform float u_seed;
float hash(vec2 p) {
  return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
}
void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  float t = floor(u_time * 15.0);
  vec2 off = vec2(
    hash(vec2(floor(v_uv.y * 500.0), u_seed + t)) - 0.5,
    hash(vec2(floor(v_uv.x * 500.0), u_seed + t + 1.0)) - 0.5
  ) * u_amount * px;
  outColor = texture(u_texture, v_uv + off);
}`,
    animated: true,
    setUniforms: floats("amount", "seed")
  },
  wobble: {
    fragment: H + `uniform float u_amount;
uniform float u_frequency;
uniform float u_speed;

// Value noise helpers
float hash(vec2 p) {
  return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453);
}
float noise(vec2 p) {
  vec2 i = floor(p);
  vec2 f = fract(p);
  f = f * f * (3.0 - 2.0 * f); // smoothstep
  return mix(
    mix(hash(i), hash(i + vec2(1.0, 0.0)), f.x),
    mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), f.x),
    f.y
  );
}
// Fractal Brownian motion \u2014 3 octaves
float fbm(vec2 p) {
  float v = 0.0;
  v += 0.5    * noise(p); p *= 2.13;
  v += 0.25   * noise(p); p *= 2.07;
  v += 0.125  * noise(p);
  return v / 0.875;
}

void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  float t = u_time * u_speed;
  vec2 st = v_uv * u_frequency;

  // 2D noise-based displacement \u2014 varies in both axes
  float ox = fbm(st + vec2(t * 0.7, t * 0.3)) - 0.5;
  float oy = fbm(st + vec2(t * -0.4, t * 0.8) + 50.0) - 0.5;

  vec2 off = vec2(ox, oy) * 2.0 * u_amount * px;
  outColor = texture(u_texture, v_uv + off);
}`,
    animated: true,
    setUniforms: floats("amount", "frequency", "speed")
  },
  slices: {
    fragment: H + `uniform float u_count;
uniform float u_offset;
uniform int u_direction;
float hash(float n) { return fract(sin(n) * 43758.5453); }
void main() {
  vec2 uv = v_uv;
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  if (u_direction == 0) {
    float slice = floor(uv.y * u_count);
    uv.x += (hash(slice) - 0.5) * u_offset * px.x;
  } else {
    float slice = floor(uv.x * u_count);
    uv.y += (hash(slice) - 0.5) * u_offset * px.y;
  }
  outColor = texture(u_texture, uv);
}`,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_count", v.count);
      setFloat(gl, l, "u_offset", v.offset);
      setInt(gl, l, "u_direction", v.direction === "vertical" ? 1 : 0);
    }
  },
  shake: {
    fragment: H + `uniform float u_amount;
uniform float u_speed;
float hash(float n) { return fract(sin(n * 12.9898) * 43758.5453); }
void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  float t = floor(u_time * u_speed);
  vec2 off = vec2(
    (hash(t) - 0.5) * 2.0,
    (hash(t + 7.0) - 0.5) * 2.0
  ) * u_amount * px;
  outColor = texture(u_texture, v_uv + off);
}`,
    animated: true,
    setUniforms: floats("amount", "speed")
  },
  glow: {
    prePasses: [
      {
        // Pass 1: threshold + horizontal Gaussian blur
        fragment: H + `uniform float u_cutoff;
uniform float u_radius;
uniform vec2 u_resolution;
void main() {
  vec2 px = 1.0 / u_resolution;
  float spread = u_radius * 3.0;
  float sigma = spread * 0.4;
  float invSigma2 = 1.0 / max(sigma * sigma, 0.001);
  vec3 bloom = vec3(0.0);
  float totalW = 0.0;
  const int R = 16;
  float step = spread / float(R);
  for (int i = -R; i <= R; i++) {
    float fi = float(i) * step;
    float w = exp(-fi * fi * invSigma2);
    vec2 off = vec2(fi * px.x, 0.0);
    vec3 s = texture(u_texture, v_uv + off).rgb;
    float luma = dot(s, vec3(0.299, 0.587, 0.114));
    float contrib = max(0.0, luma - u_cutoff);
    bloom += s * contrib * contrib * w;
    totalW += w;
  }
  bloom /= totalW;
  outColor = vec4(bloom, 1.0);
}`,
        linearFilter: true
      },
      {
        // Pass 2: vertical Gaussian blur
        fragment: H + GLOW_VBLUR_FRAG,
        linearFilter: true
      }
    ],
    // Final pass: composite blurred bloom with original
    fragment: H + `uniform float u_amount;
uniform sampler2D u_original;
void main() {
  vec4 orig = texture(u_original, v_uv);
  vec3 bloom = texture(u_texture, v_uv).rgb;
  outColor = vec4(orig.rgb + bloom * u_amount, orig.a);
}`,
    setUniforms: floats("amount", "cutoff", "radius")
  },
  "soft-glitch": {
    fragment: H + `uniform float u_amount;
float h1(float n) { return fract(sin(n) * 43758.5453); }
float vnoise(float x) {
  float i = floor(x);
  float f = fract(x);
  return mix(h1(i), h1(i + 1.0), f * f * (3.0 - 2.0 * f));
}
// rotate hue by angle (radians)
vec3 hrot(vec3 c, float a) {
  float ca = cos(a), sa = sin(a);
  vec3 k = vec3(0.57735);
  return c*ca + cross(k,c)*sa + k*dot(k,c)*(1.0-ca);
}
void main() {
  float strength = u_amount / 50.0;
  float t = u_time;

  // Burst/calm envelope: long quiet stretches, then violent fits
  float burst = smoothstep(0.55, 0.85, vnoise(t * 0.45));
  float activity = strength * (0.15 + 1.6 * burst);

  vec2 readUV = v_uv;
  float hueShift = 0.0;
  float ghost = 0.0;
  float invertFlash = 0.0;

  // 6 bands, each on its OWN clock speed -> poly-rhythm, never one pulse
  for (int i = 0; i < 6; i++) {
    float fi = float(i);
    float clock = 1.3 + h1(fi * 9.7) * 4.2;
    float et = floor(t * clock);
    if (h1(et * 0.41 + fi * 4.1) > activity + 0.18) continue;

    float top = h1(et * 1.7 + fi * 6.3);
    float ht  = mix(0.02, 0.28, h1(et * 3.1 + fi * 2.9));
    float y = v_uv.y;
    if (y < top || y >= top + ht) continue;

    float typeR = h1(et * 5.3 + fi * 8.7);
    if (typeR < 0.25) {
      // content stolen from another row
      float srcY = h1(et * 2.9 + fi * 1.3);
      readUV = vec2(v_uv.x, srcY + fract(y - top) * ht);
    } else if (typeR < 0.5) {
      // horizontal shift + wrong-color hue rotation
      float xOff = (h1(et * 7.1 + fi) - 0.5) * strength * 1.8;
      readUV = vec2(clamp(v_uv.x + xOff, 0.0, 1.0), y);
      hueShift = h1(et * 3.3 + fi * 5.5) * 6.28;
    } else if (typeR < 0.68) {
      // row-duplication stutter
      float stripeH = ht / 4.0;
      float srcRow = top + h1(et * 4.4 + fi) * ht * 0.5;
      readUV = vec2(v_uv.x, srcRow + mod(y - top, stripeH));
    } else if (typeR < 0.84) {
      // vertical slip: the band slides up/down
      float yOff = (h1(et * 6.2 + fi) - 0.5) * strength * 0.8;
      readUV = vec2(v_uv.x, clamp(y + yOff, 0.0, 1.0));
      hueShift = (h1(et * 1.9 + fi) - 0.5) * 1.2;
    } else {
      // ghost echo: translucent shifted duplicate
      ghost = 0.4 + h1(et * 8.8 + fi) * 0.4;
    }
    break;
  }

  // Rare full-frame events, only during bursts
  float ft = floor(t * 14.0);
  if (burst > 0.0 && h1(ft * 0.173) > 1.0 - 0.06 * burst) {
    float kind = h1(ft * 0.731);
    if (kind < 0.45) {
      // full-frame tear below a random line
      float tearY = h1(ft * 1.37);
      float off = (h1(ft * 2.11) - 0.5) * strength * 1.2;
      if (readUV.y > tearY) readUV.x = clamp(readUV.x + off, 0.0, 1.0);
    } else if (kind < 0.75) {
      invertFlash = 1.0;
    } else {
      hueShift += 3.14159;
    }
  }

  vec4 s = texture(u_texture, readUV);
  if (ghost > 0.0) {
    vec2 gOff = vec2((h1(floor(t * 3.0) * 7.7) - 0.5) * 0.24 * strength,
                     (h1(floor(t * 3.0) * 3.3) - 0.5) * 0.05);
    vec4 g = texture(u_texture, clamp(v_uv + gOff, vec2(0.0), vec2(1.0)));
    s.rgb = mix(s.rgb, max(s.rgb, g.rgb), ghost);
  }
  if (hueShift != 0.0) s.rgb = hrot(s.rgb, hueShift);
  if (invertFlash > 0.5) s.rgb = 1.0 - s.rgb;
  outColor = s;
}`,
    animated: true,
    setUniforms: floats("amount")
  },
  "optical-flow": {
    fragment: H + `uniform float u_amount;
void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  vec3 lum = vec3(0.299, 0.587, 0.114);
  float t = u_time * 0.2;

  float r = 3.0 * max(px.x, px.y);

  // 4th-order central-difference gradient \u2014 smooth, suppresses per-pixel noise
  float gxN2 = dot(texture(u_texture, v_uv - vec2(2.0*r, 0.0)).rgb, lum);
  float gxN1 = dot(texture(u_texture, v_uv - vec2(    r, 0.0)).rgb, lum);
  float gxP1 = dot(texture(u_texture, v_uv + vec2(    r, 0.0)).rgb, lum);
  float gxP2 = dot(texture(u_texture, v_uv + vec2(2.0*r, 0.0)).rgb, lum);
  float gyN2 = dot(texture(u_texture, v_uv - vec2(0.0, 2.0*r)).rgb, lum);
  float gyN1 = dot(texture(u_texture, v_uv - vec2(0.0,     r)).rgb, lum);
  float gyP1 = dot(texture(u_texture, v_uv + vec2(0.0,     r)).rgb, lum);
  float gyP2 = dot(texture(u_texture, v_uv + vec2(0.0, 2.0*r)).rgb, lum);
  float gx = (-gxP2 + 8.0*gxP1 - 8.0*gxN1 + gxN2) * (1.0/12.0);
  float gy = (-gyP2 + 8.0*gyP1 - 8.0*gyN1 + gyN2) * (1.0/12.0);

  // Curl of luminance gradient = divergence-free flow (follows colour contours)
  vec2 curl = vec2(-gy, gx);

  // Two layered sine waves at incommensurate frequencies \u2014 live animation
  float d1 = sin(v_uv.x * 3.1 + t) * cos(v_uv.y * 2.7 - t * 0.73);
  float d2 = sin(v_uv.y * 4.3 - t * 1.3 + 1.57) * cos(v_uv.x * 3.7 + t * 0.91);
  vec2 drift = vec2(d1, d2) * 0.2;

  // Soft-normalise: ensures both strong-edge and flat regions produce visible flow
  vec2 rawFlow = curl + drift;
  vec2 flowDir = rawFlow / max(length(rawFlow), 0.08);

  // LIC-style streamline accumulation:
  // Step N times backward along the flow direction, blending colours with
  // exponential decay weights \u2014 this is what turns a plain warp into the
  // characteristic elongated liquid-paint / pour-paint brush-stroke look.
  float stepLen = r * (1.0 + u_amount * 6.0);
  vec2  stepVec = flowDir * stepLen;

  vec4  color  = vec4(0.0);
  float totalW = 0.0;
  vec2  pos    = v_uv;
  const int N  = 10;
  for (int i = 0; i < N; i++) {
    float w = exp(-2.2 * float(i) / float(N - 1));
    color  += texture(u_texture, pos) * w;
    totalW += w;
    pos    -= stepVec;
  }
  vec3 avg = (color / totalW).rgb;

  // Weighted averaging desaturates colours by blending hues toward their
  // neighbours along the streamline. Re-expand chroma to restore vibrancy.
  float avgLuma = dot(avg, lum);
  avg = mix(vec3(avgLuma), avg, 1.35);

  outColor = vec4(clamp(avg, 0.0, 1.0), 1.0);
}`,
    animated: true,
    setUniforms: floats("amount")
  },
  vhs: {
    fragment: H + `uniform float u_noise;
uniform float u_tracking;
float hash(vec2 p) {
  return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
}
float hash1(float n) {
  return fract(sin(n * 43758.5453) * 28947.3);
}
void main() {
  vec2 res = vec2(textureSize(u_texture, 0));
  vec2 px = 1.0 / res;
  float t = u_time;
  float tFrame = floor(t * 30.0);
  float row = floor(v_uv.y * res.y);
  float colPx = floor(v_uv.x * res.x);

  // --- Drifting hotspot regions where static concentrates ---
  float hotspot = clamp(0.5 + 0.3 * sin(v_uv.y * 6.0 + t * 0.5)
                            + 0.2 * sin(v_uv.y * 17.0 - t * 0.8), 0.0, 1.0);

  // --- Static bands (2-5 px tall) with random lifetimes ---
  float bandH = 2.0 + hash(vec2(floor(row / 3.0), 444.0)) * 3.0;
  float bandId = floor(row / bandH);
  float lifeLen = 2.0 + floor(hash(vec2(bandId, 123.0)) * 7.0);
  float bandEpoch = floor(tFrame / lifeLen);
  float bandChance = hash(vec2(bandId, bandEpoch * 7.0));
  float isStaticBand = step(1.0 - u_noise * 0.5 * hotspot, bandChance);

  // --- Horizontal displacement of static bands ---
  float shiftDir = hash(vec2(bandId, bandEpoch * 13.0 + 50.0)) - 0.5;
  float shiftAmt = isStaticBand * shiftDir * u_noise * 40.0 * px.x;

  // --- Streak: hot head decaying into a noisy tail; some are dark dropouts ---
  float streakX0 = hash(vec2(bandId * 3.0, bandEpoch + 77.0));
  float lenSeed = hash(vec2(bandId * 7.0, bandEpoch + 33.0));
  float streakLen = 0.03 + lenSeed * 0.15 + step(0.8, lenSeed) * 0.12;
  float sx = (v_uv.x - streakX0) / streakLen;
  float inStreak = isStaticBand * step(0.0, sx) * step(sx, 1.0);
  float env = smoothstep(0.0, 0.1, sx) * pow(max(1.0 - sx, 0.0), 1.6);
  float sparkle = 0.5 + 0.5 * hash(vec2(colPx + bandId * 91.0, tFrame));
  float toneSeed = hash(vec2(bandId, bandEpoch * 3.0));
  float dropout = step(0.75, toneSeed);
  float streakSig = inStreak * env * sparkle * (0.45 + toneSeed * 0.55) * u_noise;

  // --- Per-line jitter + sporadic warp bands ---
  float scanY = floor(v_uv.y * 480.0);
  float lineNoise = (hash(vec2(scanY, floor(t * 10.0))) - 0.5) * u_noise * 4.0 * px.x;
  float warpA = (hash(vec2(floor(v_uv.y * 80.0), floor(t * 6.0))) - 0.5)
    * step(0.75, hash(vec2(floor(v_uv.y * 80.0) + 100.0, floor(t * 6.0))))
    * u_noise * 15.0 * px.x;

  // --- Tracking bars crawling vertically ---
  float bars = 0.0;
  for (int i = 0; i < 4; i++) {
    float fi = float(i);
    float speed = 0.08 + hash1(fi * 7.0 + 1.0) * 0.25;
    float bw = 0.02 + hash1(fi * 13.0 + 3.0) * 0.06;
    float phase = hash1(fi * 19.0 + 5.0);
    float pos = fract(t * speed + phase + sin(t * speed * 3.7 + fi) * 0.08);
    float dist = abs(v_uv.y - pos);
    dist = min(dist, 1.0 - dist);
    float strength = 0.3 + hash1(fi * 11.0 + 9.0) * 0.7;
    bars += smoothstep(bw, 0.0, dist) * strength;
  }
  bars *= u_tracking;
  float barNoise = bars * hash(vec2(colPx, row + tFrame * 31.0));

  float totalWarp = lineNoise + warpA + shiftAmt + bars * 25.0 * px.x;
  float rOff = totalWarp * 1.2;
  float bOff = totalWarp * -0.8;

  // --- Sample with RGB split ---
  vec4 c;
  c.r = texture(u_texture, v_uv + vec2(rOff, 0.0)).r;
  c.g = texture(u_texture, v_uv + vec2(totalWarp * 0.3, 0.0)).g;
  c.b = texture(u_texture, v_uv + vec2(bOff, 0.0)).b;
  c.a = 1.0;

  // --- Streaks: bright ones add, dropouts pull toward black ---
  c.rgb += streakSig * (1.0 - dropout);
  c.rgb -= streakSig * dropout * 1.6;

  // --- Chroma speckle on static bands (blue/yellow shimmer) ---
  float chroma = isStaticBand * u_noise * 0.25;
  c.r += (hash(vec2(colPx * 1.3, row + tFrame)) - 0.5) * chroma;
  c.b += (hash(vec2(colPx * 1.7, row - tFrame)) - 0.5) * chroma;

  // --- Tracking bar interior: noise fill instead of a flat lift ---
  c.rgb = mix(c.rgb, vec3(barNoise), min(bars * 0.45, 0.85));

  outColor = vec4(clamp(c.rgb, 0.0, 1.0), 1.0);
}`,
    animated: true,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_noise", v.static);
      setFloat(gl, l, "u_tracking", v.tracking);
    }
  },
  duotone: {
    fragment: H + `uniform float u_shadowHue;
uniform float u_highlightHue;
uniform float u_intensity;
vec3 hsl2rgb(float h) {
  float hr = h / 60.0;
  float x = 1.0 - abs(mod(hr, 2.0) - 1.0);
  vec3 c;
  if (hr < 1.0) c = vec3(1.0, x, 0.0);
  else if (hr < 2.0) c = vec3(x, 1.0, 0.0);
  else if (hr < 3.0) c = vec3(0.0, 1.0, x);
  else if (hr < 4.0) c = vec3(0.0, x, 1.0);
  else if (hr < 5.0) c = vec3(x, 0.0, 1.0);
  else c = vec3(1.0, 0.0, x);
  return c;
}
void main() {
  vec4 c = texture(u_texture, v_uv);
  float luma = dot(c.rgb, vec3(0.299, 0.587, 0.114));
  vec3 shadow = hsl2rgb(u_shadowHue) * 0.3;
  vec3 highlight = hsl2rgb(u_highlightHue);
  vec3 duo = mix(shadow, highlight, luma);
  outColor = vec4(mix(c.rgb, duo, u_intensity), c.a);
}`,
    setUniforms: floats("shadowHue", "highlightHue", "intensity")
  },
  grain: {
    fragment: H + `uniform float u_amount;
uniform float u_rgb;
uniform int u_blendMode;
// Sine-free hash (Dave Hoskins): stable on ANGLE/D3D where fract(sin(x)*K)
// collapses to a constant for large x \u2014 with pixel coords it must not.
float hash(vec2 p) {
  vec3 p3 = fract(vec3(p.xyx) * 0.1031);
  p3 += dot(p3, p3.yzx + 33.33);
  return fract((p3.x + p3.y) * p3.z);
}
vec3 blendSoftLight(vec3 base, vec3 blend) {
  return mix(
    2.0 * base * blend + base * base * (1.0 - 2.0 * blend),
    2.0 * base * (1.0 - blend) + sqrt(base) * (2.0 * blend - 1.0),
    step(0.5, blend)
  );
}
void main() {
  vec4 c = texture(u_texture, v_uv);
  float frame = floor(u_time * 24.0);

  // Hard per-pixel speckle: one hash per pixel, no interpolation \u2014 crisp
  // grains that re-seat every frame and boil like film.
  vec2 p = floor(gl_FragCoord.xy) + frame * vec2(13.7, 57.3);

  // RGB mode gives each channel its own grain -> colored speckle
  vec3 g = u_rgb > 0.5
    ? vec3(hash(p), hash(p + 19.19), hash(p + 47.47))
    : vec3(hash(p));

  vec3 result;
  if (u_blendMode == 0) {
    // Additive: uniform response, grain reads in shadows and highlights alike
    result = c.rgb + (g - 0.5) * u_amount * 1.2;
  } else if (u_blendMode == 1) {
    result = mix(c.rgb, blendSoftLight(c.rgb, g), u_amount * 1.5);
  } else {
    result = c.rgb * mix(vec3(1.0), g * 1.6, u_amount);
  }
  outColor = vec4(clamp(result, 0.0, 1.0), c.a);
}`,
    animated: true,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_amount", v.amount);
      setFloat(gl, l, "u_rgb", v.rgb);
      const mode = v.blendMode === "softlight" ? 1 : v.blendMode === "multiply" ? 2 : 0;
      setInt(gl, l, "u_blendMode", mode);
    }
  },
  polar: {
    fragment: H + BOUNCE_GLSL + `uniform float u_amount;
uniform float u_angle;
void main() {
  vec2 uv = v_uv - 0.5;
  float r = length(uv) * 2.0;
  float a = atan(uv.y, uv.x) / 6.28318530 + 0.5 + u_angle / 360.0;
  vec2 polarUV = vec2(fract(a), bounce(r));
  outColor = mix(texture(u_texture, v_uv), texture(u_texture, polarUV), u_amount);
}`,
    setUniforms: floats("amount", "angle")
  },
  tile: {
    fragment: H + `uniform float u_size;
uniform float u_offset;
uniform float u_angle;
void main() {
  float rad = u_angle * 3.14159265 / 180.0;
  float c = cos(rad), s = sin(rad);
  vec2 centered = v_uv - 0.5;
  vec2 rotated = vec2(c * centered.x + s * centered.y, -s * centered.x + c * centered.y) + 0.5;
  vec2 uv = rotated * u_size + u_offset + vec2(u_time * 0.2, 0.0);
  vec2 cell = floor(uv);
  vec2 local = fract(uv);
  vec2 mirrored = mix(local, 1.0 - local, mod(cell, 2.0));
  outColor = texture(u_texture, mirrored);
}`,
    animated: true,
    setUniforms: floats("size", "offset", "angle")
  },
  "data-bend": {
    fragment: H + `uniform float u_intensity;
uniform float u_corruption;
uniform float u_channelShift;
float hash(vec2 p) {
  return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
}
vec3 hrot(vec3 c, float a) {
  float ca = cos(a), sa = sin(a);
  vec3 k = vec3(0.57735);
  return c*ca + cross(k,c)*sa + k*dot(k,c)*(1.0-ca);
}
void main() {
  vec2 res = vec2(textureSize(u_texture, 0));
  // Corruption layout persists: quantize phase-time coarsely
  float t = floor(u_time * 0.8);

  // Macroblock grid (raster order, like bytes in a file)
  float gridW = 40.0;
  float gridH = max(4.0, floor(gridW * res.y / res.x));
  vec2 grid = vec2(gridW, gridH);
  vec2 bc = floor(v_uv * grid);
  vec2 local = fract(v_uv * grid);
  float bIdx = bc.y * gridW + bc.x;
  float total = gridW * gridH;

  float numZones = floor(2.0 + u_corruption * 10.0);

  vec2 readBlock = bc;
  vec2 readLocal = local;
  float rasterShift = 0.0;
  float garbage = 0.0;
  float hueG = 0.0;

  for (float i = 0.0; i < 12.0; i++) {
    if (i >= numZones) break;
    // Corrupt zones are runs of consecutive blocks in raster order,
    // wrapping row edges like a corrupted byte stream.
    float zStart = floor(hash(vec2(i, t)) * total);
    float zLen = floor((0.01 + hash(vec2(i + 50.0, t)) * 0.06)
      * total * (0.3 + u_intensity));
    float zEnd = zStart + zLen;

    // The classic databend signature: everything AFTER the broken bytes
    // stays shifted sideways for the zone's lifetime.
    if (bIdx >= zEnd) {
      rasterShift += floor((hash(vec2(i * 3.0, t + 7.0)) - 0.5)
        * u_intensity * 7.0);
    }

    if (bIdx >= zStart && bIdx < zEnd) {
      float fate = hash(vec2(i * 11.0, t + 3.0));
      if (fate < 0.45) {
        // wrong content: this block decodes bytes from elsewhere
        float srcIdx = mod(bIdx + floor((hash(vec2(i * 5.0, t)) - 0.5)
          * total * 0.5) + total, total);
        readBlock = vec2(mod(srcIdx, gridW), floor(srcIdx / gridW));
      } else if (fate < 0.75) {
        // smear: the block repeats its first row downward (JPEG streak)
        readLocal.y = readLocal.y * 0.08;
      } else {
        // garbage: posterized hue trash on laterally-shifted content
        garbage = 1.0;
        hueG = hash(vec2(i * 7.0, t + 9.0)) * 6.28;
        readBlock.x = mod(readBlock.x + floor(hash(vec2(i, t + 4.0)) * 8.0), gridW);
      }
    }
  }

  // Re-linearize with the persistent raster shift
  float rIdx = readBlock.y * gridW + readBlock.x + rasterShift;
  rIdx = clamp(rIdx, 0.0, total - 1.0);
  vec2 rb = vec2(mod(rIdx, gridW), floor(rIdx / gridW));
  vec2 uv = (rb + readLocal) / grid;

  // RGB byte misalignment: channels offset by fractions of a block
  float co = u_channelShift * 2.5 / gridW;
  vec3 col;
  col.r = texture(u_texture, clamp(uv, vec2(0.0), vec2(1.0))).r;
  col.g = texture(u_texture, clamp(uv + vec2(co, 0.0), vec2(0.0), vec2(1.0))).g;
  col.b = texture(u_texture, clamp(uv + vec2(co * 2.0, 0.0), vec2(0.0), vec2(1.0))).b;

  if (garbage > 0.5) {
    col = floor(col * 5.0) / 5.0;
    col = hrot(col, hueG);
  }
  outColor = vec4(col, 1.0);
}`,
    animated: true,
    setUniforms: floats("intensity", "corruption", "channelShift")
  },
  melt: {
    fragment: H + `uniform float u_amount;
uniform float u_delta;
uniform sampler2D u_feedback;
float hash(vec2 p) {
  return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
}
float vnoise(vec2 p) {
  vec2 i = floor(p);
  vec2 f = fract(p);
  vec2 u = f * f * (3.0 - 2.0 * f);
  return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), u.x),
             mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x), u.y);
}
float fbm(vec2 p) {
  return vnoise(p) * 0.55 + vnoise(p * 2.13 + 5.0) * 0.3
       + vnoise(p * 4.41 + 9.0) * 0.15;
}
void main() {
  vec3 lum = vec3(0.299, 0.587, 0.114);
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  float t = u_time;

  // --- Drip field ---------------------------------------------------------
  // Broad slow columns crossed with fine streaks; wanders gently over time.
  float cols = fbm(vec2(v_uv.x * 4.0, t * 0.05));
  float streaks = fbm(vec2(v_uv.x * 47.0 + 13.0, t * 0.021));
  float drip = cols * cols * (0.3 + 0.7 * streaks);

  // A melting front descends per column, so drips grow downward over time
  // instead of the whole image sliding at once.
  float front = t * u_amount * (0.02 + 0.3 * cols);
  float meltOn = smoothstep(0.0, 0.18, front - v_uv.y);

  // Bright wax runs faster.
  float bright = dot(texture(u_feedback, v_uv).rgb, lum);

  // Per-frame fall distance (uv units), framerate-independent via u_delta.
  float fall = u_delta * u_amount * meltOn
             * (0.05 + 1.6 * drip) * (0.35 + 0.65 * bright) * 0.06;

  // Moving drips swing sideways; amplitude scales with their speed.
  float sway = sin(v_uv.y * 21.0 - t * 1.4 + cols * 6.2831) * fall * 2.2;

  // Advection: this pixel receives what was slightly above it last frame
  // (+v_uv.y is screen-down in effect space).
  vec2 from = vec2(clamp(v_uv.x + sway, 0.0, 1.0),
                   clamp(v_uv.y - fall, 0.0, 1.0));
  vec3 melted = texture(u_feedback, from).rgb;

  // --- Viscous softening ---------------------------------------------------
  // Only where actually flowing: fast drips smear and blend like wax,
  // untouched areas stay perfectly crisp.
  float visc = 0.7 * clamp(fall / (px.y * 1.5), 0.0, 1.0);
  vec3 up   = texture(u_feedback, clamp(from + vec2(0.0, px.y * 1.5), vec2(0.0), vec2(1.0))).rgb;
  vec3 down = texture(u_feedback, clamp(from - vec2(0.0, px.y * 1.5), vec2(0.0), vec2(1.0))).rgb;
  melted = mix(melted, (melted * 2.0 + up + down) * 0.25, visc);

  // --- Re-solidifying ------------------------------------------------------
  // The source image constantly seeps back through the wax, so the melt
  // reaches a living equilibrium instead of burying the input. Higher
  // amounts drip faster and re-solidify slower, but never fully take over.
  vec3 fresh = texture(u_texture, v_uv).rgb;
  float heal = 1.0 - exp(-mix(2.0, 0.25, u_amount) * u_delta);
  melted = mix(melted, fresh, heal);

  // Where the front hasn't arrived yet, show the live chain input so
  // unmelted regions (and upstream animated effects) stay alive.
  vec3 col = mix(fresh, melted, meltOn);

  outColor = vec4(clamp(col, 0.0, 1.0), 1.0);
}`,
    animated: true,
    setUniforms: floats("amount")
  },
  tunnel: {
    fragment: H + `uniform float u_zoom;
uniform float u_spin;
uniform float u_decay;
uniform float u_delta;
uniform sampler2D u_feedback;
void main() {
  // Pull last frame slightly toward/around the center: infinite zoom tunnel.
  // Out-of-bounds samples mirror (texture wrap), folding the edges back in.
  float s = 1.0 - u_zoom * u_delta * 0.8;
  float a = u_spin * (3.14159265 / 180.0) * u_delta;
  vec2 c = v_uv - 0.5;
  float ca = cos(a), sa = sin(a);
  c = vec2(ca * c.x - sa * c.y, sa * c.x + ca * c.y) * s;
  // Decay knob is inverted (higher = fades faster) and cropped to the
  // usable 0.90\u20131.00 per-frame multiplier range.
  float fade = 1.0 - u_decay * 0.1;
  vec3 prev = texture(u_feedback, c + 0.5).rgb * pow(fade, u_delta * 60.0);
  vec3 fresh = texture(u_texture, v_uv).rgb;
  outColor = vec4(clamp(max(fresh, prev), 0.0, 1.0), 1.0);
}`,
    animated: true,
    setUniforms: floats("zoom", "spin", "decay")
  },
  halftone: {
    fragment: H + `uniform float u_scale;
uniform float u_angle;
uniform float u_contrast;
uniform float u_invert;
uniform int u_mode;
void main() {
  vec2 res = vec2(textureSize(u_texture, 0));
  vec2 pos = v_uv * res;
  vec3 src = texture(u_texture, v_uv).rgb;
  float lum = dot(src, vec3(0.299, 0.587, 0.114));
  lum = clamp((lum - 0.5) * u_contrast + 0.5, 0.0, 1.0);

  float rad = u_angle * 3.14159265 / 180.0;
  float ca = cos(rad), sa = sin(rad);
  vec2 rp = vec2(ca * pos.x + sa * pos.y, -sa * pos.x + ca * pos.y);

  float ink; // 1 = inked
  if (u_mode == 1) {
    // Ordered 4x4 Bayer dither, one threshold per image pixel
    const float B[16] = float[16](
      0.0, 8.0, 2.0, 10.0,
      12.0, 4.0, 14.0, 6.0,
      3.0, 11.0, 1.0, 9.0,
      15.0, 7.0, 13.0, 5.0
    );
    vec2 bp = floor(mod(pos, 4.0));
    float th = (B[int(bp.y * 4.0 + bp.x)] + 0.5) / 16.0;
    ink = step(th, lum);
  } else if (u_mode == 2) {
    // Engraving lines; a second, perpendicular set joins in dark areas
    float aa = 1.5 * 3.14159265 / u_scale;
    float w1 = 0.5 + 0.5 * sin(rp.y * 3.14159265 / u_scale);
    float w2 = 0.5 + 0.5 * sin(rp.x * 3.14159265 / u_scale);
    float l1 = 1.0 - smoothstep(w1 - aa, w1 + aa, lum);
    float l2 = 1.0 - smoothstep(w2 - aa, w2 + aa, lum * 2.0);
    ink = max(l1, l2);
  } else {
    // Classic rotated dot screen: dot area grows with darkness
    vec2 cell = fract(rp / u_scale) - 0.5;
    float r = sqrt(1.0 - lum) * 0.7071;
    ink = smoothstep(r, r - 1.5 / u_scale, length(cell));
  }
  ink = mix(ink, 1.0 - ink, u_invert);
  // Ink takes the source color over paper white
  vec3 col = mix(vec3(1.0), src, ink);
  outColor = vec4(col, 1.0);
}`,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_scale", v.scale);
      setFloat(gl, l, "u_angle", v.angle);
      setFloat(gl, l, "u_contrast", v.contrast);
      setFloat(gl, l, "u_invert", v.invert);
      setInt(gl, l, "u_mode", v.mode === "dither" ? 1 : v.mode === "lines" ? 2 : 0);
    }
  },
  swirl: {
    fragment: H + `uniform float u_angle;
uniform float u_radius;
void main() {
  vec2 res = vec2(textureSize(u_texture, 0));
  float aspect = res.x / res.y;
  vec2 c = v_uv - 0.5;
  c.x *= aspect;
  float d = length(c);
  // Whirlpool profile: full twist at the core with a quadratic falloff
  // to zero at u_radius \u2014 the shear stays concentrated in the middle
  // instead of streaking the whole disc into rings.
  float infl = 1.0 - smoothstep(0.0, u_radius, d);
  infl *= infl;
  // Bounded rocking around the base twist instead of endless wind-up,
  // so the vortex breathes instead of spiraling into mush.
  float a = (u_angle + sin(u_time * 0.8) * 60.0) * (3.14159265 / 180.0) * infl;
  float ca = cos(a), sa = sin(a);
  vec2 r = vec2(ca * c.x - sa * c.y, sa * c.x + ca * c.y);
  vec2 uv = vec2(r.x / aspect, r.y) + 0.5;
  outColor = texture(u_texture, uv);
}`,
    animated: true,
    linearFilter: true,
    setUniforms: floats("angle", "radius")
  },
  ripple: {
    fragment: H + `uniform float u_amount;
uniform float u_frequency;
void main() {
  vec2 res = vec2(textureSize(u_texture, 0));
  vec2 px = 1.0 / res;
  float aspect = res.x / res.y;
  vec2 c = v_uv - 0.5;
  c.x *= aspect;
  float d = length(c);
  float wave = sin(d * u_frequency * 6.2831 - u_time * 4.0) / (1.0 + d * 3.0);
  vec2 dir = d > 0.0001 ? c / d : vec2(0.0);
  vec2 uv = v_uv + dir * wave * u_amount * px;
  outColor = texture(u_texture, uv);
}`,
    animated: true,
    setUniforms: floats("amount", "frequency")
  },
  blur: {
    prePasses: [
      {
        fragment: H + BLUR_H_FRAG,
        linearFilter: true
      },
      {
        fragment: H + GLOW_VBLUR_FRAG,
        linearFilter: true
      }
    ],
    fragment: H + `void main() {
  outColor = texture(u_texture, v_uv);
}`,
    setUniforms: floats("radius")
  },
  ascii: {
    fragment: H + `uniform float u_size;
uniform int u_color;
uniform sampler2D u_glyphs;
uniform vec2 u_resolution;
void main() {
  // Grid must follow the render-target size, not the input texture size \u2014
  // the source texture keeps natural dimensions while FBOs use output size.
  vec2 res = u_resolution;
  vec2 pos = v_uv * res;
  vec2 cellId = floor(pos / u_size);
  vec3 cell = texture(u_texture, (cellId + 0.5) * u_size / res).rgb;
  float lum = dot(cell, vec3(0.299, 0.587, 0.114));
  // Slight gamma-lift: dark cells keep sparse-but-visible glyphs,
  // bright cells jump to dense ones
  float gi = floor(pow(lum, 0.8) * 15.999);
  // Organic variation: jitter the glyph choice per cell (\xB11 coverage step)
  float h = fract(sin(dot(cellId, vec2(12.9898, 78.233))) * 43758.5453);
  gi = clamp(gi + (h < 0.25 ? -1.0 : h > 0.75 ? 1.0 : 0.0), 0.0, 15.0);
  vec2 local = fract(pos / u_size);
  // 16x1 glyph atlas, sparsest (space) leftmost
  float g = texture(u_glyphs, vec2((gi + local.x) / 16.0, local.y)).r;
  vec3 tint = u_color == 1 ? vec3(0.25, 1.0, 0.35)
            : u_color == 2 ? vec3(1.0)
            : cell;
  // Dense glyphs blaze, sparse glyphs stay dim but visible
  float gf = gi / 15.0;
  outColor = vec4(g * (tint * (1.2 + gf) + 0.07), 1.0);
}`,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_size", v.size);
      setInt(gl, l, "u_color", v.color === "green" ? 1 : v.color === "white" ? 2 : 0);
    }
  },
  "radial-blur": {
    fragment: H + `uniform float u_strength;
void main() {
  vec2 c = v_uv - 0.5;
  vec3 col = vec3(0.0);
  float total = 0.0;
  for (int i = 0; i < 12; i++) {
    float t = float(i) / 11.0;
    float w = 1.0 - 0.5 * t;
    col += texture(u_texture, v_uv - c * t * u_strength * 0.25).rgb * w;
    total += w;
  }
  outColor = vec4(col / total, 1.0);
}`,
    setUniforms: floats("strength")
  },
  emboss: {
    fragment: H + `uniform float u_strength;
uniform float u_angle;
uniform float u_mix;
void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  float rad = u_angle * 3.14159265 / 180.0;
  vec2 dir = vec2(cos(rad), sin(rad));
  vec2 off = dir * max(px.x, px.y) * 2.0;
  float s1 = dot(texture(u_texture, v_uv - off).rgb, vec3(0.299, 0.587, 0.114));
  float s2 = dot(texture(u_texture, v_uv + off).rgb, vec3(0.299, 0.587, 0.114));
  float diff = (s2 - s1) * u_strength + 0.5;
  vec3 emboss = clamp(vec3(diff), 0.0, 1.0);
  vec4 orig = texture(u_texture, v_uv);
  outColor = vec4(mix(orig.rgb, emboss, u_mix), orig.a);
}`,
    setUniforms: floats("strength", "angle", "mix")
  },
  thermal: {
    fragment: H + `uniform float u_intensity;
uniform int u_palette;
vec3 thermalRamp(float t) {
  vec3 c0 = vec3(0.0, 0.0, 0.0);
  vec3 c1 = vec3(0.2, 0.0, 0.5);
  vec3 c2 = vec3(0.6, 0.0, 0.6);
  vec3 c3 = vec3(1.0, 0.0, 0.0);
  vec3 c4 = vec3(1.0, 0.5, 0.0);
  vec3 c5 = vec3(1.0, 1.0, 0.0);
  vec3 c6 = vec3(1.0, 1.0, 1.0);
  float s0 = smoothstep(0.0, 0.2, t);
  float s1 = smoothstep(0.2, 0.4, t);
  float s2 = smoothstep(0.4, 0.55, t);
  float s3 = smoothstep(0.55, 0.7, t);
  float s4 = smoothstep(0.7, 0.85, t);
  float s5 = smoothstep(0.85, 1.0, t);
  return mix(mix(mix(mix(mix(mix(c0, c1, s0), c2, s1), c3, s2), c4, s3), c5, s4), c6, s5);
}
vec3 infraredRamp(float t) {
  vec3 c0 = vec3(0.1, 0.0, 0.2);
  vec3 c1 = vec3(0.4, 0.0, 0.5);
  vec3 c2 = vec3(0.8, 0.2, 0.6);
  vec3 c3 = vec3(1.0, 0.6, 0.8);
  vec3 c4 = vec3(1.0, 1.0, 1.0);
  float s0 = smoothstep(0.0, 0.25, t);
  float s1 = smoothstep(0.25, 0.5, t);
  float s2 = smoothstep(0.5, 0.75, t);
  float s3 = smoothstep(0.75, 1.0, t);
  return mix(mix(mix(mix(c0, c1, s0), c2, s1), c3, s2), c4, s3);
}
vec3 nightVisionRamp(float t) {
  vec3 c0 = vec3(0.0, 0.05, 0.0);
  vec3 c1 = vec3(0.0, 0.3, 0.0);
  vec3 c2 = vec3(0.2, 0.6, 0.1);
  vec3 c3 = vec3(0.5, 1.0, 0.4);
  vec3 c4 = vec3(0.9, 1.0, 0.9);
  float s0 = smoothstep(0.0, 0.25, t);
  float s1 = smoothstep(0.25, 0.5, t);
  float s2 = smoothstep(0.5, 0.75, t);
  float s3 = smoothstep(0.75, 1.0, t);
  return mix(mix(mix(mix(c0, c1, s0), c2, s1), c3, s2), c4, s3);
}
void main() {
  vec4 c = texture(u_texture, v_uv);
  float luma = dot(c.rgb, vec3(0.299, 0.587, 0.114));
  vec3 ramp;
  if (u_palette == 0) ramp = thermalRamp(luma);
  else if (u_palette == 1) ramp = infraredRamp(luma);
  else ramp = nightVisionRamp(luma);
  outColor = vec4(mix(c.rgb, ramp, u_intensity), c.a);
}`,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_intensity", v.intensity);
      const p = v.palette;
      setInt(
        gl,
        l,
        "u_palette",
        p === "infrared" ? 1 : p === "night-vision" ? 2 : 0
      );
    }
  },
  "color-halves": {
    fragment: H + HUE_ROTATE_GLSL + `uniform float u_position;
uniform float u_angle;
uniform int u_mode;
uniform float u_amount;
void main() {
  vec4 orig = texture(u_texture, v_uv);
  float rad = u_angle * 3.14159265 / 180.0;
  vec2 center = vec2(0.5);
  vec2 uv = v_uv - center;
  float c = cos(rad), s = sin(rad);
  float proj = uv.x * c + uv.y * s;
  float feather = 0.02;
  float side = smoothstep(u_position - feather, u_position + feather, proj + 0.5);
  vec3 treated = orig.rgb;
  if (u_mode == 0) {
    treated = hueRotate(treated, 180.0);
  } else if (u_mode == 1) {
    treated = hueRotate(treated, 120.0);
  } else if (u_mode == 2) {
    float luma = dot(treated, vec3(0.299, 0.587, 0.114));
    treated = mix(treated, vec3(luma), 1.0);
  } else {
    treated = clamp((orig.rgb - 0.5) * 2.0 + 0.5, 0.0, 1.0);
  }
  vec3 result = mix(orig.rgb, treated, side * u_amount);
  outColor = vec4(result, orig.a);
}`,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_position", v.position);
      setFloat(gl, l, "u_angle", v.angle);
      const m = v.mode;
      setInt(
        gl,
        l,
        "u_mode",
        m === "hue-shift" ? 1 : m === "desaturate" ? 2 : m === "high-contrast" ? 3 : 0
      );
      setFloat(gl, l, "u_amount", v.amount);
    }
  },
  stereoscopic: {
    fragment: H + `uniform float u_depth;
uniform float u_angle;
uniform int u_mode;
uniform int u_depthSource;
uniform float u_focus;
void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  vec4 c = texture(u_texture, v_uv);

  // compute depth value
  float d;
  if (u_depthSource == 0) {
    // luminance-based depth
    d = dot(c.rgb, vec3(0.299, 0.587, 0.114));
  } else if (u_depthSource == 1) {
    // edge-based depth (gradient magnitude)
    float lL = dot(texture(u_texture, v_uv + vec2(-px.x, 0.0)).rgb, vec3(0.299, 0.587, 0.114));
    float lR = dot(texture(u_texture, v_uv + vec2( px.x, 0.0)).rgb, vec3(0.299, 0.587, 0.114));
    float lT = dot(texture(u_texture, v_uv + vec2(0.0, -px.y)).rgb, vec3(0.299, 0.587, 0.114));
    float lB = dot(texture(u_texture, v_uv + vec2(0.0,  px.y)).rgb, vec3(0.299, 0.587, 0.114));
    d = clamp(length(vec2(lR - lL, lB - lT)) * 4.0, 0.0, 1.0);
  } else {
    // flat \u2014 uniform offset
    d = 1.0;
  }

  // offset centered around focus point (focus inverted: high focus = less offset)
  float offset = (d - (1.0 - u_focus)) * u_depth;
  float rad = u_angle * 3.14159265 / 180.0;
  vec2 dir = vec2(cos(rad), sin(rad)) * offset * px;

  if (u_mode == 0) {
    // anaglyph red/cyan
    float r = texture(u_texture, v_uv + dir).r;
    vec2 gb = texture(u_texture, v_uv - dir).gb;
    outColor = vec4(r, gb, c.a);
  } else {
    // color split \u2014 offset per channel in 3 directions
    float r = texture(u_texture, v_uv + dir).r;
    float g = texture(u_texture, v_uv).g;
    float b = texture(u_texture, v_uv - dir).b;
    outColor = vec4(r, g, b, c.a);
  }
}`,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_depth", v.depth);
      setFloat(gl, l, "u_angle", v.angle);
      const m = v.mode;
      setInt(gl, l, "u_mode", m === "color-split" ? 1 : 0);
      const ds = v.depthSource;
      setInt(
        gl,
        l,
        "u_depthSource",
        ds === "edges" ? 1 : ds === "flat" ? 2 : 0
      );
      setFloat(gl, l, "u_focus", v.focus);
    }
  },
  "pixel-sort": {
    fragment: H + `uniform float u_threshold;
uniform float u_ceiling;
uniform float u_range;
uniform int u_direction;
uniform float u_reverse;
void main() {
  vec2 px = 1.0 / vec2(textureSize(u_texture, 0));
  vec4 c = texture(u_texture, v_uv);
  float luma = dot(c.rgb, vec3(0.299, 0.587, 0.114));
  float lo = min(u_threshold, u_ceiling);
  float hi = max(u_threshold, u_ceiling);
  float span = hi - lo;
  float norm = span > 0.001 ? (clamp(luma, lo, hi) - lo) / span : 0.0;
  float sign = (u_reverse > 0.5) ? -1.0 : 1.0;
  float disp = norm * u_range * sign;
  vec2 offset = u_direction == 0 ? vec2(disp * px.x, 0.0) : vec2(0.0, disp * px.y);
  outColor = texture(u_texture, v_uv + offset);
}`,
    setUniforms: (gl, l, v) => {
      setFloat(gl, l, "u_threshold", v.threshold);
      setFloat(gl, l, "u_ceiling", v.ceiling);
      setFloat(gl, l, "u_range", v.range);
      setInt(gl, l, "u_direction", v.direction === "vertical" ? 1 : 0);
      setFloat(gl, l, "u_reverse", v.reverse);
    }
  },
  smear: {
    fragment: H + BOUNCE_GLSL + `uniform float u_amount;
uniform float u_angle;
void main() {
  // Self-displacement: shift each pixel by the image's own red/green
  // channels, so content flows along its own color field \u2014 smooth,
  // ghosty warps instead of directional streaks.
  vec2 off = texture(u_texture, v_uv).rg - 0.5;
  float ang = u_angle * 3.14159265 / 180.0;
  float ca = cos(ang);
  float sa = sin(ang);
  off = mat2(ca, -sa, sa, ca) * off;
  vec2 p = v_uv + off * u_amount * 0.2;
  outColor = texture(u_texture, vec2(bounce(p.x), bounce(p.y)));
}`,
    setUniforms: floats("amount", "angle")
  },
  relief: {
    fragment: H + `uniform float u_amount;
uniform float u_angle;

void main() {
  vec3 lum = vec3(0.299, 0.587, 0.114);

  float rad = u_angle * 3.14159265 / 180.0;
  vec2 dir = vec2(cos(rad), sin(rad));

  // Parallax occlusion mapping: treat luma as a height field.
  // Cast a ray descending from height=1 to 0 while stepping in dir.
  // Track prev step so we can interpolate the exact intersection \u2014
  // this eliminates staircase artifacts and gives smooth ridges.
  const int N = 64;
  vec2  stepUV = dir * u_amount / float(N);
  float stepH  = 1.0 / float(N);

  vec2  pos      = v_uv;
  float rayH     = 1.0;
  vec2  prevPos  = v_uv;
  float prevSurfH = dot(texture(u_texture, v_uv).rgb, lum);
  vec2  hitPos   = v_uv;
  bool  found    = false;

  for (int i = 0; i < N; i++) {
				float surfH = dot(texture(u_texture, pos).rgb, lum);
				if (!found && surfH >= rayH) {
					// Linearly interpolate between prev and current step for sub-step accuracy
					float prevRayH = rayH + stepH;
					float t = (prevRayH - prevSurfH) / max((surfH - prevSurfH) - (rayH - prevRayH), 0.0001);
					hitPos = mix(prevPos, pos, clamp(t, 0.0, 1.0));
					found  = true;
				}
				prevPos   = pos;
				prevSurfH = surfH;
				pos  += stepUV;
				rayH -= stepH;
  }

  outColor = texture(u_texture, hitPos);
}`,
    setUniforms: floats("amount", "angle")
  },
  zoom: {
    fragment: H + BOUNCE_GLSL + `uniform float u_amount;
void main() {
  float scale = pow(2.0, u_amount);
  vec2 uv = (v_uv - 0.5) / scale + 0.5;
  uv = vec2(bounce(uv.x), bounce(uv.y));
  outColor = texture(u_texture, uv);
}`,
    setUniforms: floats("amount")
  },
  "fiber-displace": {
    fragment: H + BOUNCE_GLSL + `uniform float u_strength;
uniform float u_density;
uniform float u_chrome;
uniform float u_smoothness;

// Hash functions for non-repeating pseudo-random variation
float hash(float n) { return fract(sin(n) * 43758.5453123); }
float hash2(vec2 p) { return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453123); }

// Value noise for smooth random variation
float vnoise(float x) {
  float i = floor(x);
  float f = fract(x);
  f = f * f * (3.0 - 2.0 * f); // smoothstep
  return mix(hash(i), hash(i + 1.0), f);
}

void main() {
  vec2 ts = vec2(textureSize(u_texture, 0));

  // Non-repeating fiber displacement using value noise layers
  float x = v_uv.x * u_density;

  // Multiple noise octaves at irrational frequency ratios = no visible repeat
  float fiber = vnoise(x * 1.0) * 1.0
              + vnoise(x * 2.37 + 5.1) * 0.5
              + vnoise(x * 5.09 + 11.3) * 0.25
              + vnoise(x * 10.71 + 23.7) * 0.125;
  fiber = fiber / 0.9375 * 2.0 - 1.0; // normalize to [-1, 1]

  // Smoothness: sample neighbors and average
  float px = 1.0 / ts.x;
  float sm = u_smoothness * 8.0;
  float xL = (v_uv.x - px * sm) * u_density;
  float xR = (v_uv.x + px * sm) * u_density;
  float fiberL = vnoise(xL) + 0.5 * vnoise(xL * 2.37 + 5.1) + 0.25 * vnoise(xL * 5.09 + 11.3) + 0.125 * vnoise(xL * 10.71 + 23.7);
  fiberL = fiberL / 0.9375 * 2.0 - 1.0;
  float fiberR = vnoise(xR) + 0.5 * vnoise(xR * 2.37 + 5.1) + 0.25 * vnoise(xR * 5.09 + 11.3) + 0.125 * vnoise(xR * 10.71 + 23.7);
  fiberR = fiberR / 0.9375 * 2.0 - 1.0;
  fiber = mix(fiber, (fiberL + fiber + fiberR) / 3.0, u_smoothness);

  // Displace vertically (strength 0-1 maps to 0-0.1 actual displacement)
  float disp = fiber * u_strength * 0.1;
  vec2 uv = vec2(v_uv.x, bounce(v_uv.y + disp));

  vec4 c = texture(u_texture, uv);

  // Luminance and edge detection for specular
  float lum = dot(c.rgb, vec3(0.299, 0.587, 0.114));
  float lumUp = dot(texture(u_texture, vec2(uv.x, bounce(uv.y + 1.0 / ts.y))).rgb, vec3(0.299, 0.587, 0.114));
  float lumDn = dot(texture(u_texture, vec2(uv.x, bounce(uv.y - 1.0 / ts.y))).rgb, vec3(0.299, 0.587, 0.114));
  float spec = pow(clamp(abs(lumUp - lumDn) * ts.y * 0.01, 0.0, 1.0), 0.5);

  // Smooth continuous phase variation \u2014 no discrete stripe boundaries
  float phase = vnoise(v_uv.x * u_density * 0.7 + 100.0)
              + vnoise(v_uv.x * u_density * 1.73 + 50.0) * 0.5
              + vnoise(v_uv.y * 2.5 + v_uv.x * u_density * 0.3) * 0.2;

  // 6-stop color ramp offset by unique stripe phase
  vec3 c0 = vec3(0.02, 0.03, 0.15);  // deep blue-black
  vec3 c1 = vec3(0.0, 0.35, 0.55);   // teal
  vec3 c2 = vec3(0.9, 0.4, 0.08);    // warm orange
  vec3 c3 = vec3(0.7, 0.15, 0.4);    // magenta
  vec3 c4 = vec3(1.0, 0.82, 0.5);    // gold
  vec3 c5 = vec3(0.95, 0.95, 1.0);   // near-white

  float t = fract(lum + phase);
  vec3 ramp;
  if (t < 0.2) {
    ramp = mix(c0, c1, t * 5.0);
  } else if (t < 0.35) {
    ramp = mix(c1, c2, (t - 0.2) * 6.667);
  } else if (t < 0.5) {
    ramp = mix(c2, c3, (t - 0.35) * 6.667);
  } else if (t < 0.7) {
    ramp = mix(c3, c4, (t - 0.5) * 5.0);
  } else {
    ramp = mix(c4, c5, (t - 0.7) * 3.333);
  }

  ramp += spec * vec3(0.3, 0.25, 0.35);

  outColor = vec4(mix(c.rgb, ramp, u_chrome), 1.0);
}`,
    setUniforms: floats("strength", "density", "chrome", "smoothness")
  }
};
var ANIMATED_EFFECTS = new Set(
  Object.entries(EFFECT_SHADERS).filter(([, def]) => def.animated).map(([id]) => id)
);
ANIMATED_EFFECTS.add("tracking");
